import { sourceByKey } from "../lib/sources";

export const SourceBadge = ({ source, size = "sm" }) => {
  const s = sourceByKey(source);
  const sizes = {
    xs: "px-1.5 py-0.5 text-[10px]",
    sm: "px-2 py-0.5 text-[11px]",
    md: "px-2.5 py-1 text-xs",
  };
  return (
    <span
      data-testid={`source-badge-${s.key}`}
      className={`inline-flex items-center gap-1 font-bold uppercase tracking-wider rounded-full ${sizes[size] || sizes.sm}`}
      style={{ backgroundColor: s.bg, color: s.text }}
      title={s.domain || s.label}
    >
      <span
        className="inline-block w-1.5 h-1.5 rounded-full"
        style={{ backgroundColor: s.color }}
      />
      {s.label}
    </span>
  );
};
